<template>
  <section >
    <div class="hero-body">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>

export default {
  data: function () {
    return {
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style scoped>
  a {
    text-decoration: none;
  }
</style>